import axios from 'axios'
import { errorHandler } from '@/api/error-handler'

export default {
  searchSuggestions (ressource, fieldName, prefix) {
    if (ressource === 'cultivations' || ressource === 'targets') {
      return axios.get(`/${ressource}/search_suggestions?prefix=${prefix}`)
        .then(response => response.data)
        .catch(errorHandler)
    }

    return axios.get(`/${ressource}/search_suggestions/${fieldName}?prefix=${prefix}`)
      .then(response => response.data)
      .catch(errorHandler)
  }
}
